export const stateSelected = {
    event: "state_selected",
    eventAction: "State_selected",
    eventCategory: "Challan_homepage"
};
